import { MDText } from 'i18n-react';

import { Button, ShareIcon } from '@motorway/mw-highway-code';
import { INTENT, VARIANT } from '@motorway/mw-highway-code/enums';
import { toast } from '@motorway/mw-highway-code/pre-alpha';

import LocalTexts from './ShareLinkButtons.texts.json';

import styles from './ShareLinkButtons.module.scss';

const LocalT = new MDText(LocalTexts);

export type ShareLinkButtonsProps = {
  copy: (value: string) => Promise<void>;
  isCopied: boolean;
  onCopy?: (label: string) => void;
  onShare?: (label: string) => void;
  shareText?: string;
  shareTitle?: string;
  url: string;
};

export const ShareLinkButtons = ({
  copy,
  isCopied,
  onCopy,
  onShare,
  shareText,
  shareTitle,
  url,
}: ShareLinkButtonsProps) => {
  const shareData = {
    ...(shareText ? { text: shareText } : {}),
    ...(shareTitle ? { title: shareTitle } : {}),
    url,
  };

  const canShare = globalThis?.navigator?.canShare?.(shareData);

  const handleCopy = () => {
    copy(url);
    onCopy?.(LocalT.translate('copy') as string);
  };

  const handleShare = () => {
    onShare?.(LocalT.translate('share') as string);

    globalThis?.navigator?.share(shareData)?.catch((err) => {
      if (err?.name === 'AbortError') {
        return;
      }

      toast({
        content: LocalT.translate('pleaseCopy') as string,
        heading: LocalT.translate('unableToShare') as string,
        variant: INTENT.ERROR,
      });
    });
  };

  return (
    <div className={styles.shareLinkButtons}>
      <Button
        disabled={isCopied}
        label={LocalT.translate(isCopied ? 'copied' : 'copy') as string}
        onClick={handleCopy}
        variant={VARIANT.SECONDARY}
      />
      {canShare && (
        <Button
          icon={ShareIcon}
          label={LocalT.translate('share') as string}
          onClick={handleShare}
          variant={VARIANT.PRIMARY}
        />
      )}
    </div>
  );
};
